// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1kJdH","amount":"Amount_amount__1WDxT","tip":"Amount_tip__1OapZ","tipHeader":"Amount_tipHeader__2g6gW","tipsWrap":"Amount_tipsWrap__3xTVz"};